<template>
  <div class="mt-10" style="background-color: #F5F6F9;">
    <popup :message="notif.alertErrMessage" v-if="notif.isAlertErr" @close="notif.isAlertErr = false" />
    <div class="hero">
      <div class="content">
        <h1>{{ $t('event.heroSection.heading') }}</h1>
        <p>
          {{ $t('event.heroSection.subHeading') }}
        </p>
        <div class="btn-cta">
          <button class="now" @click="scrollToSection('event-recommendation')">
            {{ $t('event.heroSection.ctaButton') }}
          </button>
        </div>
      </div>
      <div class="card-img">
        <img src="/img/event/banner.png" width="556" height="392" alt="event-banner" />
      </div>
    </div>
    <div class="container" style="text-align: center;">
      <div class="section-container">
        <h1 class="sub-title-span" style="margin: 0;">{{ $t('event.benefitsSection.title') }}</h1>
        <span class="font-poppins">{{ $t('event.benefitsSection.description') }}</span>
        <div class="card-bootcamp">
          <div v-for="n in $t('event.benefitsSection.benefits')" :key="n.id" class="content-card">
            <div class="left-span">
              <img :src="n.image" width="104" height="104" />
            </div>
            <div class="title-2">{{ n.title }}</div>
            <div class="desc mt-2" style="font-family: 'Poppins', sans-serif;">{{ n.desc }}</div>
          </div>
        </div>
      </div>
      <div class="section-container" id="event-recommendation">
        <h1 class="sub-title-span" style="margin: 0;">{{ $t('event.recommendationsSection.title') }}</h1>
        <span class="font-poppins">{{ $t('event.recommendationsSection.description') }}</span>
        <div class="event-list" v-if="events.length > 0">
          <div class="event-box" v-for="(item, idx) in events" :key="idx" :title="item.name" @click="toDetail(item)">
            <img :src="item.img_urls.desktop.thumbnail" alt="Content" class="event-box-img" />
            <div class="event-ctn">
              <div style="text-align: left;">
                <div class="event-ctn-label">
                  <span>{{ item.category.name }}</span>
                </div>
                <div style="height: 65px; margin-top: 10px;">
                  <h3 class="judul-event">{{ item.name }} {{ item.batch ? "Batch " + item.batch : '' }}</h3>
                </div>
                <div class="event-ctn-info" style="margin-top: 0;">
                  <DateIcon :width="18" :height="18" />
                  <span class="name">{{ moment(item.session_schedules[0].date_start) }}</span>
                </div>
                <div class="event-ctn-info">
                  <Clock :width="18" :height="18" />
                  <span class="name">{{ item.session_schedules[0].start_time }} - {{ item.session_schedules[0].end_time
                  }} WIB</span>
                </div>
                <div class="event-ctn-info">
                  <Participants :width="18" :height="18" />
                  <span class="name">{{ item.participant_quota > 0 ? `${item.participant_quota} ${$t('event.a1')}` :
                    $t('event.a2') }}</span>
                </div>
                <div class="event-ctn-info">
                  <Methode :width="18" :height="18" />
                  <span class="name">{{ item.method | toMethode }}</span>
                </div>
                <div class="event-ctn-info" v-if="item.instructors.length">
                  <Speaker :width="18" :height="18" fill="#7B7E8C" />
                  <span class="name">{{ item.instructors[0].name
                  }}<span v-if="item.instructors.length > 1">, {{ item.instructors.length - 1 }}+ {{ $t('event.a3')
                    }}</span></span>
                </div>
                <div style="height: 35px" v-else></div>
                <div style="height: 50px; margin-top: 24px;">
                  <div v-if="checkIsEarlyBird(item)">
                    <span class="ebp-text">{{ item.label_discount }}</span>
                    <div class="after-price-ctn">
                      <span class="discount-price">{{ item.price != 0 ? toCurrency(item.price) : '' }}</span>
                      <span class="event-price">{{ (item.price - item.discount_price) ? toCurrency(item.price -
                        item.discount_price) : $t('event.a4') }}</span>
                    </div>
                  </div>
                  <div class="event-price" v-else>
                    {{ item.price ? toCurrency(item.price) : $t('event.a4') }}
                  </div>
                </div>
                <div v-if="item.expired.length" style="display: flex; justify-content: center; margin-top: 16px;">
                  <Button :name="$t('event.a5')" :bold="true" width="250px" @click="() => toDetail(item)" />
                </div>
                <div v-else style="display: flex; justify-content: center; margin-top: 16px;">
                  <button class="btn-disable" disabled>
                    <CloseSlash :width="20" :height="20" />
                    <span>{{ $t('event.a6') }}</span>
                  </button>
                </div>
                <div class="event-due-date" v-if="item.expired.length">
                  <div class="event-due-date-ctn">
                    <span class="event-due-date-key">{{ item.expired[0] }}</span>
                    <span class="event-due-date-value">{{ $t('event.a7') }}</span>
                  </div>
                  <span>:</span>
                  <div class="event-due-date-ctn">
                    <span class="event-due-date-key">{{ item.expired[1] }}</span>
                    <span class="event-due-date-value">{{ $t('event.a8') }}</span>
                  </div>
                  <span>:</span>
                  <div class="event-due-date-ctn">
                    <span class="event-due-date-key">{{ item.expired[2] }}</span>
                    <span class="event-due-date-value">{{ $t('event.a9') }}</span>
                  </div>
                  <span>:</span>
                  <div class="event-due-date-ctn">
                    <span class="event-due-date-key">{{ item.expired[3] }}</span>
                    <span class="event-due-date-value">{{ $t('event.a10') }}</span>
                  </div>
                </div>
                <div v-else style="height: 48px;"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="empty-data" v-else>
          <img src="/img/empty_folder.png" alt="">
          <div class="empty-data-text">
            <h3>{{ $t('event.recommendationsSection.emptyState.heading') }}</h3>
            <p>{{ $t('event.recommendationsSection.emptyState.subHeading') }}</p>
          </div>
        </div>
        <v-row justify="center" style="margin-top: 30px;" v-if="total > 1">
          <v-col>
            <Pagination @pageChanged="onPageChanged" :currentPage="currentPage" :totalPages="total" />
          </v-col>
        </v-row>
      </div>


    </div>
    <div class="bg">
      <div class="box-content">
        <div>
          <span class="title font-poppins">{{ $t('event.consultationSection.title') }}</span>
          <div>
            <span class="description font-poppins">{{ $t('event.consultationSection.description') }}</span>
          </div>
        </div>
        <div>
          <div class="d-flex bg-yellow justify-center" @click="contactMe">
            <span class="exhange-voucher font-poppins">{{ $t('event.consultationSection.ctaButton') }}</span>
          </div>
        </div>
      </div>
  </div>
  </div>
</template>

<script>
import moment from "moment";
import Button from "../../others/Button.vue";
import Clock from "@/assets/icons/Clock2.vue";
import DateIcon from "@/assets/icons/Calendar2.vue";
import Speaker from "@/assets/icons/UsersOctagon.vue";
import Methode from "@/assets/icons/Presentation.vue";
import Popup from "@/components/others/Popup.vue";
import Participants from '@/assets/icons/Participants.vue';
import CloseSlash from "@/assets/icons/CloseSlash.vue";
import Pagination from '@/components/others/Pagination.vue'

export default {
  name: "EventDesktop",
  data() {
    return {
      currentPage: 1,
      total: 0,
      perPage: 12,
      notif: {
        alertErrMessage: "",
        isAlertErr: false,
      },
      events: [],
      isAlertErr: false,
    };
  },
  components: {
    Button,
    DateIcon,
    Popup,
    Clock,
    Methode,
    Speaker,
    Participants,
    CloseSlash,
    Pagination
  },
  watch: {
    "$i18n.locale"() {
      this.getDataEvents();
    },
  },
  methods: {
    contactMe() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Contact Us - WhatsApp - Event Desktop',
        value: 1,
      });
      window.open(
        "https://api.whatsapp.com/send/?phone=6285110563798&text=Hi%20Kak%20HiColleagues,%20saya%20mau%20bertanya",
        "_blank"
      );
    },
    moment(date) {
      return moment(date).format("dddd, DD MMMM YYYY");
    },
    async getTotalRegistran(id) {
      try {
        const resp = await this.$http.get(`/v1/event/${id}/registrant`);
        return resp.data.data.total_registrants;
      } catch (error) {
        console.log(error);
        return 0;
      }
    },
    // async toCheckout(item) {
    //   this.$gtag.event('click', {
    //     event_category: 'Navigation',
    //     event_label: `Event Checkout - ${item.name} - Event Desktop`,
    //     value: 1,
    //   });
    //   const total_registrants = await this.getTotalRegistran(item.slug_name);
    //   if (total_registrants >= item.participant_quota && item.participant_quota !== 0) {
    //     this.notif.isAlertErr = true;
    //     this.notif.alertErrMessage = "Kouta pendaftaran sudah penuh";
    //     this.$gtag.event('checkout_error', {
    //       event_category: 'Checkout',
    //       event_label: `Event Checkout Error - ${item.name} - Event Desktop`,
    //       value: 0,
    //     });
    //     return;
    //   }
    //   this.$router.push("/checkout/event/" + item.slug_name);
    // },
    toDetail(item) {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: `View Event Detail - ${item.name} - Event Desktop`,
        value: 1,
      });
      this.$router.push("/event/detail/" + item.slug_name);
    },
    discountPercent(event) {
      return Math.round(((event.price - (event.price - event.discount_price)) / (event.price)) * 100);
    },
    countDownTimer() {
      const _second = 1000;
      const _minute = _second * 60;
      const _hour = _minute * 60;
      const _day = _hour * 24;
      let days, hours, minutes, seconds;
      const showRemaining = () => {
        this.events.forEach((item) => {
          const end = new Date(item.registration_close_date);
          const now = new Date();
          const distance = end - now;
          if (distance < 0) {
            item.expired = [];
            return;
          }
          days = Math.floor(distance / _day);
          hours = Math.floor((distance % _day) / _hour);
          minutes = Math.floor((distance % _hour) / _minute);
          seconds = Math.floor((distance % _minute) / _second);
          item.expired = [days, hours, minutes, seconds];
        });
      };
      setInterval(showRemaining, 1000);
    },
    async getDataEvents() {
      try {
        const resp = await this.$http.get(`/v1/event?is_active=true&page=${this.currentPage}&per_page=${this.perPage}`);
        this.events = resp.data.data.events.map((item) => ({
          ...item,
          session_schedules: item.session_schedules ? item.session_schedules
            ? item.session_schedules
            : [
              {
                date_end: "",
                date_start: "",
                end_time: "",
                start_time: "",
              },
            ] : [{
              date_end: "",
              date_start: "",
              end_time: "",
              start_time: "",
            }],
          img_urls: Object.keys(item.img_urls).length
            ? item.img_urls
            : {
              desktop: {
                product_detail: "",
                purchase_detail: "",
                thumbnail: "",
              },
              mobile: {
                product_detail: "",
                purchase_detail: "",
                thumbnail: "",
              },
            },
          expired: [],
        }));
        this.total = parseInt(resp.data.data.total / this.perPage) + 1;
      } catch (err) {
        console.log(err);
      }
    },
    onPageChanged(page) {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: `Change Page - Page ${page} - Event Desktop`,
        value: 1,
      });
      this.currentPage = page;
      this.getDataEvents();
    },
    checkIsEarlyBird(item) {
      if (new Date(item.start_discount_date) <= new Date() && new Date(item.end_discount_date) >= new Date()) {
        return true;
      } else {
        return false;
      }
    },
    toCurrency(value) {
      if (typeof value !== "number") {
        return value;
      }
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
      return formatter.format(value);
    },
    scrollToSection(sectionId) {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Explore Events - Scroll to Recommendations - Event Desktop',
        value: 1,
      });
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    },
  },
  mounted() {
    this.getDataEvents();
    this.countDownTimer();
    window.scrollTo(0, 0);
    this.$gtag.pageview(this.$route);
  },
};
</script>

<style src="./event.css" scoped></style>